import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
@Component({
  selector: 'app-dpnf-success',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, CommonModule],
  templateUrl: './dpnf-success.component.html',
  styleUrl: './dpnf-success.component.scss',
})
export class DpnfSuccessComponent implements OnInit {
  public isMobileDevice: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,     private isMobile: CommonUtilService,) {}
  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
  }
}
